<template>
  <div class="timeline-intro" id="intro" :class="{ 'fade': selectedDecade !== 0 }">
    <div class="container">
      <h2>{{ introHeadline }}</h2>
      <div class="card-wrapper">
        <div v-for="block in introCards" :key="block.id" class="card">
          <div class="card-header">
            <h2>{{ block.header }}</h2>
          </div>
          <div class="card-content">
            <p>{{ block.description }}</p>
          </div>
        </div>
      </div>
      <button id="start" class="button" @click="handleButtonClick">See the history</button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  data() {
    return {
      introHeadline: '',
      introCards: []
    };
  },
  computed: {
    ...mapState(['entryId', 'selectedDecade', 'decades'])
  },
  methods: {
    ...mapActions(['fetchIntroData', 'selectDecade']),
    handleButtonClick() {
      if (this.decades.length > 0) {
        this.selectDecade(this.decades[0]);
      }
    },
    loadIntroData() {
      if (this.entryId) {
        this.fetchIntroData(this.entryId).then(data => {
          this.introHeadline = data.introHeadline;
          this.introCards = data.introCards;
          this.$nextTick(this.equalizeCardHeaders);
        });
      }
    },
    equalizeCardHeaders() {
      const headers = this.$el.querySelectorAll('.card-header');
      const maxHeight = Math.max(...Array.from(headers).map(header => header.offsetHeight));
      headers.forEach(header => (header.style.height = `${maxHeight}px`));
    }
  },
  mounted() {
    this.loadIntroData();
    window.addEventListener('resize', this.equalizeCardHeaders);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.equalizeCardHeaders);
  }
};
</script>


// WEBPACK FOOTER //
// Intro.vue?dd51a4d0